import React, { useRef, useState, useEffect }  from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,TextArea,ImageUploader,DatePicker,NavBar,Toast ,Grid,Image,Avatar,InfiniteScroll
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import {
    GetMediaFile,CreateWxConfig,GetWXJSSDK,PostRecordingDetails,SaveRecordingDetails
    ,UpdateRecordingDetailById,DelRecordingDetailById,SaveUserAction
} from '../../service/service';

import { environment } from '../../service/baseUrl';
import { useNavigate,useParams,useLocation } from 'react-router-dom';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

const AudioPlayer = ({ audioSrc }) => {
    const audioRef = useRef(null);
    const [duration, setDuration] = useState(0);
    const [divWidth, setDivWidth] = useState(0);
    const [remainingTime, setRemainingTime] = useState(0);
    const [videoPlay, setVideoPlay] = useState(false);
  
    const handlePlay = () => {
      if (audioRef.current) {
        audioRef.current.play();
      }
    };
  
    const handlePause = () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  
    useEffect(() => {
        // 组件挂载时设置音频源文件
        if (audioRef.current) {
            audioRef.current.src = audioSrc;
        }

        const audio = audioRef.current;
        const handleLoadedMetadata = () => {
            setDuration(audio.duration); // 获取音频时长
            setRemainingTime(audio.duration); // 初始化剩余时间
            setDivWidth((0.5 * audio.duration.toFixed(0)) + 60)
        };

        const handleTimeUpdate = () => {
            const remaining = duration - audio.currentTime; // 计算剩余时间
            setRemainingTime(remaining);
        };

        const handleEnded = () => {
            setVideoPlay(false); // 播放结束时，将状态设置为 false
            setRemainingTime(duration); // 重置剩余时间
        };

        audio.addEventListener("loadedmetadata", handleLoadedMetadata);
        audio.addEventListener("timeupdate", handleTimeUpdate); // 添加 timeupdate 事件监听器
        audio.addEventListener("ended", handleEnded);

        // 组件卸载时清理（如果需要的话）
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.src = ''; // 清空src属性，防止内存泄漏
            }
            audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
            audio.removeEventListener("timeupdate", handleTimeUpdate); // 移除 timeupdate 事件监听器
            audio.removeEventListener("ended", handleEnded);
        };
    }, [audioSrc, duration]); // 仅在audioSrc更改时运行此effect
  
    return (
        <div>
            <audio ref={audioRef} style={{ height: "35px" }} controlsList="nodownload novolume">
                <source src={audioSrc} type="audio/mpeg" />
                您的浏览器不支持audio元素。
            </audio>

            <div style={{
                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/31-12.png')"
                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "30px", width: divWidth + "%"
                , alignItems: "center", display: "flex"
            }} onClick={() => {
                if (!videoPlay) {
                    handlePlay();
                    setVideoPlay(true);
                } else {
                    handlePause();
                    setVideoPlay(false);
                }
            }}>
                <Image src={"https://api.weibinyi.com/images/niannian/4/31-13.png"} fit='fill'
                    width={30} height={25} style={{ marginLeft: "20px" }} />
                <span style={{ marginRight: "10px", marginLeft: "15px", fontSize: "14px", color: "#fff", fontWeight: "700" }}>
                    {/* {duration.toFixed(0)}" */}
                    {remainingTime.toFixed(0)}" {/* 显示剩余时间 */}
                </span>
                <span style={{ marginLeft: "10px", fontSize: "13px" }}>
                    {
                        videoPlay ? "点击暂停" : "点击播放"
                    }
                </span>
            </div>

        </div>
    );
  };


class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            userInfo: {},
            fileList: [],
            myFileList: [],
            myTotalCount:0,
            allTotalCount: 0,
            localId: "",
            titleTab: 0,
            record: false,
            loading: false,
            hasMore: true,
            page: 0,
            pageSize: 10
        };
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
        script.async = true;
        document.body.appendChild(script);

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
            })

            // 初始化加载数据
            this.loadData();
        }

        var jsApiList = [
            "onMenuShareAppMessage",
            'startRecord',
            'stopRecord',
            'playVoice',
            'uploadVoice',
            'onVoiceRecordEnd',
        ];

        setTimeout(() => {

            var url = window.location.href.split('#')[0];
            // var url = environment.domainUrl;
            GetWXJSSDK(encodeURIComponent(url)).then(res => {

                var json = JSON.parse(res.result);
                json.jsApiList = jsApiList;
                json.appId = json.AppId;
                json.debug = true;
                json.nonceStr = json.noncestr;
                
                window.wx.config({
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    timestamp: parseInt(json.timestamp), // 必填，生成签名的时间戳
                    nonceStr: json.nonceStr, // 必填，生成签名的随机串
                    signature: json.signature,// 必填，签名
                    jsApiList: jsApiList, // 必填，需要使用的 JS 接口列表
                    appId: json.appId, // 必填，公众号的唯一标识
                });

            })
        }, 1000);

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    loadData = (loadMore = false) => {
        var that = this;
        if (this.state.loading) return;

        const { location } = this.props;
        const { id } = location.state || {};
        if (!id) return;

        this.setState({ loading: true });

        const currentPage = loadMore ? this.state.page + 1 : 1;
        const type = this.state.titleTab === 0 ? 1 : 2; // 1:我的声音, 2:所有声音

        const data = {
            PlanetId: id,
            Type: type == 1 ? "" : type,
            OpenId: type == 1 ? that.state.userInfo.openId : "",
            MaxResultCount: this.state.pageSize,
            SkipCount: (currentPage - 1) * this.state.pageSize,
        };

        PostRecordingDetails(data).then(res => {
            if (res.success) {
                const stateUpdate = {
                    loading: false,
                    page: currentPage,
                    hasMore: (currentPage * this.state.pageSize) < res.result.totalCount
                };

                var list = [];
                res.result.items.map(item => {
                    //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    if (item.headImg != null) {
                        if (item.headImg.indexOf("https://") > -1) {
                            var urls = item.headImg.split("https://").filter(Boolean);
                            item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        }
                    }
                    item.fileUrlName = environment.apiEndpoint + "/Files/yuyin/" + item.fileUrlName;

                    const creationTime = new Date(item.creationTime);
                    const now = new Date();
                    const timeDiff = now - creationTime; // 时间差（毫秒）
                    item.creationTime = that.formatTimeDifference(timeDiff);

                    var cUserActionDto = item.userActionDto;
                    item.yanList = cUserActionDto.filter(action => action.type === 1);
                    item.zanList = cUserActionDto.filter(action => action.type === 2);

                    list.push(item);
                })

                if (this.state.titleTab === 0) {
                    stateUpdate.myFileList = loadMore
                        ? [...this.state.myFileList, ...list]
                        : list;
                    stateUpdate.myTotalCount = res.result.totalCount;
                } else {
                    stateUpdate.fileList = loadMore
                        ? [...this.state.fileList, ...list]
                        : list;
                    stateUpdate.allTotalCount = res.result.totalCount;
                }

                this.setState(stateUpdate);
            }
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    formatTimeDifference(diffInMs) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - diffInMs).toLocaleDateString("zh-CN");
        }
    }

    handleTabChange = (tab) => {
        this.setState({ 
            titleTab: tab,
            page: 1,
            hasMore: true
        }, () => {
            this.loadData();
        });
    }

    uploadVoice = (id) => {
        var that = this;
        GetMediaFile(id, this.state.id).then(res => {
            
            if (res.result.item1) {
                var list = that.state.myFileList;
                list.push({
                    id: -list.length,
                    fileUrlName: environment.apiEndpoint + "/Files/yuyin/" + res.result.item2,
                    planetId: that.state.id,
                    type: 1,
                    mediaId: id,
                    creationTime: "刚刚",
                })

                this.setState({
                    // videoUrl: environment.apiEndpoint + "/Files/yuyin/" + res.result.item2,
                    myFileList: list,
                })

            } else {
                Toast.show({
                    // icon: 'error',
                    content: "内部错误！",
                })
            }

        })
    }


    submitForm = () => {
        var that = this;
        var list = that.state.myFileList;
        list = list.filter(x => x.id <= 0);
        list.map(item => {
            item.fileUrlName = item.fileUrlName.split('/').pop();
            item.creationTime = null;
        });

        var data = {
            RecordingDetailDtos: list
        }
        SaveRecordingDetails(data).then(res => {
            if (res.success) {
                Toast.show({ icon: 'success', content: '提交成功！' });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }else{
                Toast.show({ icon: 'fail', content: '内部异常！' });
            }
        })
    }
    
    startRecord = () => {
        var win = window;
        var that = this;

        win.wx.startRecord() // 开始录音
        Toast.show({
            icon: 'success',
            content: "开始录音",
        })

        win.wx.onVoiceRecordEnd({
            // 录音时间超过一分钟没有停止的时候会执行 complete 回调
            complete: function (res) {
                var localId = res.localId;

                that.setState({
                    localId: localId,
                    record: false
                })

                Toast.show({
                    icon: 'success',
                    content: "录音时间不能超过一分钟！",
                })

                win.wx.uploadVoice({
                    localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: function (res) {
                        var serverId = res.serverId; // 返回音频的服务器端ID

                        that.uploadVoice(serverId);
                    }
                });

            }
        });

    }

    stopRecord = () => {
        var win = window;
        var that = this;

        Toast.show({
            icon: 'success',
            content: "停止录音",
        })

        win.wx.stopRecord({
            success: function (res) {
                var localId = res.localId;
                that.setState({
                    localId: localId
                })

                win.wx.uploadVoice({
                    localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: function (res) {
                        var serverId = res.serverId; // 返回音频的服务器端ID
                        that.uploadVoice(serverId);
                    }
                });

            }
        });
    }

    renderVoiceList = (list, isMyVoice = true) => {
        return list.map((item, index) => (
            <div key={index} style={{ marginTop: "5%", color: "#a2a2a2" }}>
                <Grid columns={5}>
                    <Grid.Item span={5}>
                        <div style={{ color: "#000", fontSize: "14px" }}>
                            录音{index + 1}
                        </div>
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div style={{ margin: "7px 0px 7px 0px" }}>
                            <AudioPlayer audioSrc={item.fileUrlName} />
                        </div>
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <span>上海市</span>
                    </Grid.Item>
                    <Grid.Item span={3}>
                        <span>{item.creationTime}</span>
                    </Grid.Item>
                    {isMyVoice && (
                        <Grid.Item span={2}>
                            <span style={{ float: "right", marginRight: "5px" }} onClick={() => {
                                var that = this;
                                DelRecordingDetailById(item.id).then(res => {
                                    if (res.success) {
                                        Toast.show({
                                            icon: 'success',
                                            content: "删除成功！",
                                        })
                                        var updatedPosts = [];
                                        that.state.myFileList.map(post => {
                                            if (post.id != item.id) {
                                                updatedPosts.push(post);
                                            }
                                        });

                                        that.setState({
                                            myFileList: updatedPosts,
                                        });
                                    }
                                })
                            }}>删除</span>
                            {
                                (item.type == 2 && item.id > 0) ? null :
                                    <span style={{ float: "right", marginRight: "18px" }} onClick={() => {
                                        var that = this;
                                        UpdateRecordingDetailById(item.id).then(res => {
                                            if (res.success) {
                                                Toast.show({
                                                    icon: 'success',
                                                    content: "发布成功！",
                                                })

                                                const updatedPosts = that.state.myFileList.map(post => {
                                                    if (post.id === item.id) {
                                                        post.type = 2;
                                                    }
                                                    return post;
                                                });

                                                that.setState({
                                                    myFileList: updatedPosts,
                                                });

                                            }
                                        })
                                    }}>发布</span>
                            }
                        </Grid.Item>
                    )}
                    <Grid.Item span={5}>
                        <div style={{ borderBottom: "solid 2px #aeaeae", width: "100%", marginTop: "10px" }}></div>
                    </Grid.Item>
                </Grid>
            </div>
        ));
    }

    renderAllVoiceItem = (item, index) => {
        return (
            <div key={index} style={{ marginTop: "3%", color: "#a2a2a2" }}>
                <Grid columns={7}>
                    <Grid.Item span={1}>
                        <div style={{ margin: "12px 0px 6px 0px" }}>
                            <Avatar src={item.headImg}
                                style={{ '--size': '40px', '--border-radius': '35px', 'margin': 'auto' }} />
                        </div>
                    </Grid.Item>
                    <Grid.Item span={6}>
                        <div style={{ height: "100%", paddingTop: "6%" }}>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>{item.creatorUserName}</div>
                        </div>
                    </Grid.Item>
                    <Grid.Item span={7}>
                        <div style={{ margin: "7px 0px 7px 0px" }}>
                            <AudioPlayer audioSrc={item.fileUrlName} />
                        </div>
                    </Grid.Item>
                    <Grid.Item span={7}>
                        <span>上海市</span>
                    </Grid.Item>
                    <Grid.Item span={4}>
                        <span>{item.creationTime}</span>
                    </Grid.Item>
                    <Grid.Item span={3}>
                        <div style={{ fontSize: "15px", textAlign: "end", lineHeight: "16px" }}>
                            <Space wrap>
                                <Image src={"https://api.weibinyi.com/images/niannian/1/1-18.png"} 
                                fit='fill' width={15} height={15} />
                                <span style={{ marginRight: "15px" }}>{item.yanList.length}</span>

                                <Image src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                    fit='fill' width={15} height={15} onClick={() => {
                                        var data = {
                                            TableId: item.id,
                                            Type: 2,
                                            TableType: "RecordingDetail",
                                        };
                                        var model = item.zanList.filter(action =>
                                            action.creatorUserId === this.state.userInfo.id);
                                        if (model.length > 0) {
                                            return;
                                        }
                                        this.SaveUserAction(data);
                                    }} />
                                <span style={{ marginRight: "15px" }} onClick={() => {
                                    var data = {
                                        TableId: item.id,
                                        Type: 2,
                                        TableType: "RecordingDetail",
                                    };
                                    var model = item.zanList.filter(action =>
                                        action.creatorUserId === this.state.userInfo.id);
                                    if (model.length > 0) {
                                        return;
                                    }
                                    this.SaveUserAction(data);
                                }}>{item.zanList.length}</span>
                            </Space>
                        </div>
                    </Grid.Item>
                    <Grid.Item span={7}>
                        <div style={{ borderBottom: "solid 2px #aeaeae", width: "100%", marginTop: "10px" }}></div>
                    </Grid.Item>
                </Grid>
            </div>
        );
    }

    SaveUserAction = (data) => {
        var that = this;
        SaveUserAction(data).then(res => {
            if (res.success) {
                const updatedPosts = that.state.fileList.map(post => {
                    if (post.id === data.TableId) {
                        switch (data.Type) {
                            case 2:
                                post.zanList.push({
                                    creatorUserId: that.state.userInfo.id,
                                    type: 2,
                                })
                                break;
                            default:
                                break;
                        }
                    }
                    return post;
                });

                that.setState({
                    fileList: updatedPosts,
                });
            }
        })
    }

    render() {
        const { titleTab, myFileList, fileList, loading, hasMore } = this.state;

        return (
            <div style={{ height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}>
                    语音列表
                </NavBar>

                <div style={{
                    height: "85%", backgroundColor: this.state.titleTab === 0 ? "rgb(195 195 195)" : "#fff"
                    , overflowY: "scroll"
                }}>

                    <Grid columns={4}>
                        <Grid.Item span={2}>
                            <div style={{
                                backgroundImage: this.state.titleTab === 0
                                    ? "url('https://api.weibinyi.com/images/niannian/4/31-15.png')"
                                    : "url('https://api.weibinyi.com/images/niannian/4/31-16.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "45px", width: "100%"
                                , textAlign: "center", color: "#fff", fontSize: "17px"
                                , fontWeight: "600", lineHeight: "45px"
                            }} onClick={() => this.handleTabChange(0)}>
                                我的声音
                                </div>
                        </Grid.Item>
                        <Grid.Item span={2}>
                            <div style={{
                                backgroundImage: this.state.titleTab === 0
                                    ? "url('https://api.weibinyi.com/images/niannian/4/31-16.png')"
                                    : "url('https://api.weibinyi.com/images/niannian/4/31-15.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "45px", width: "100%"
                                , textAlign: "center", color: "#fff", fontSize: "17px"
                                , fontWeight: "600", lineHeight: "45px"
                            }} onClick={() => this.handleTabChange(1)}>
                                所有声音
                                </div>
                        </Grid.Item>
                    </Grid>

                    {
                        this.state.titleTab === 0 ?
                            <div>

                                <div style={{
                                    width: "90%", marginLeft: "5%", backgroundColor: "#fff", marginTop: "5%", marginBottom: "10%",
                                    borderRadius: "10px"
                                }}>
                                    <div style={{ width: "90%", marginLeft: "5%", paddingTop: "5%", paddingBottom: "6%" }}>
                                        <div style={{ borderBottom: "solid 2px #aeaeae", paddingBottom: "10px", color: "#a2a2a2" }}>
                                            <Grid columns={7}>
                                                <Grid.Item span={2}>
                                                    <div>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/4/31-10.png"} fit='fill'
                                                            width={75} height={75} onClick={() => {
                                                                if (!this.state.record) {
                                                                    this.startRecord();
                                                                    this.setState({
                                                                        record: true
                                                                    })
                                                                } else {
                                                                    this.stopRecord();
                                                                    this.setState({
                                                                        record: false
                                                                    })
                                                                }
                                                            }} />
                                                    </div>
                                                </Grid.Item>
                                                <Grid.Item span={5}>
                                                    <div style={{ height: "75px", marginTop: "20px" }}>
                                                        <div>
                                                            点击录制语音
                                                            {this.state.record ? "（正在录音）" : ""}
                                                            <br />（最长60秒）
                                                        </div>
                                                    </div>
                                                </Grid.Item>
                                                <Grid.Item span={5}>
                                                    <span>
                                                        所在位置
</span>
                                                </Grid.Item>
                                                <Grid.Item span={2}>
                                                    <Image src={"https://api.weibinyi.com/images/niannian/4/31-11.png"} fit='fill'
                                                        width={9} height={14} style={{ float: "right", marginTop: "2px", marginLeft: "5px" }} />
                                                    <span style={{ float: "right" }}>
                                                        上海市
</span>
                                                </Grid.Item>
                                            </Grid>
                                        </div>

                                        {/* 我的声音列表 */}
                                        {this.renderVoiceList(myFileList)}

                                        {/* 无限滚动加载 */}
                                        {
                                            this.state.page != 0 ?
                                                <InfiniteScroll
                                                    loadMore={() => this.loadData(true)}
                                                    hasMore={hasMore}
                                                    threshold={50}
                                                >
                                                    {loading && <div style={{ textAlign: 'center', padding: '10px 0' }}>加载中...</div>}
                                                    {!hasMore && <div style={{ textAlign: 'center', padding: '10px 0', color: '#999' }}>没有更多了</div>}
                                                </InfiniteScroll> : null
                                        }

                                    </div>
                                </div>


                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/31-14.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#000", marginBottom: "15px"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        保 存
    </div>
                                </div>

                            </div>
                            :
                            <div>
                                <div style={{
                                    backgroundColor: "#fff"
                                }}>
                                    <div style={{ width: "90%", marginLeft: "5%", paddingTop: "1%", paddingBottom: "6%" }}>
                                       
                                        {/* 所有声音列表 */}
                                        {fileList.map((item, index) => this.renderAllVoiceItem(item, index))}

                                        {/* 无限滚动加载 */}
                                        {
                                            this.state.page != 0 ?
                                                <InfiniteScroll
                                                    loadMore={() => this.loadData(true)}
                                                    hasMore={hasMore}
                                                    threshold={50}
                                                >
                                                    {loading && <div style={{ textAlign: 'center', padding: '10px 0' }}>加载中...</div>}
                                                    {!hasMore && <div style={{ textAlign: 'center', padding: '10px 0', color: '#999' }}>没有更多了</div>}
                                                </InfiniteScroll> : null
                                        }

                                    </div>
                                </div>

                            </div>

                    }
                    



                    <div style={{ display: "none" }}>

                        <Button color='primary' fill='solid' onClick={() => {
                            var win = window;
                            var that = this;

                            win.wx.startRecord() // 开始录音

                            win.wx.onVoiceRecordEnd({
                                // 录音时间超过一分钟没有停止的时候会执行 complete 回调
                                complete: function (res) {
                                    var localId = res.localId;

                                    that.setState({
                                        localId: localId
                                    })

                                    Toast.show({
                                        icon: 'success',
                                        content: "录音时间不能超过一分钟！",
                                    })

                                    win.wx.uploadVoice({
                                        localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                                        isShowProgressTips: 1, // 默认为1，显示进度提示
                                        success: function (res) {
                                            var serverId = res.serverId; // 返回音频的服务器端ID

                                            that.uploadVoice(serverId);

                                        }
                                    });

                                }
                            });

                        }}>
                            开始录音
          </Button>
                        <Button color='primary' fill='solid' onClick={() => {
                            var win = window;
                            var that = this;

                            win.wx.stopRecord({
                                success: function (res) {
                                    var localId = res.localId;
                                    that.setState({
                                        localId: localId
                                    })

                                    win.wx.uploadVoice({
                                        localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                                        isShowProgressTips: 1, // 默认为1，显示进度提示
                                        success: function (res) {
                                            var serverId = res.serverId; // 返回音频的服务器端ID
                                            that.uploadVoice(serverId);
                                        }
                                    });

                                }
                            });
                        }}>
                            停止录音
          </Button>

                        <Button color='primary' fill='solid' onClick={() => {

                            window.wx.playVoice({
                                localId: this.state.localId // 需要播放的音频的本地ID，由stopRecord接口获得
                            });
                        }}>
                            播放录音
                </Button>

                        {
                            this.state.showVideo ?
                                <div>
                                    <AudioPlayer audioSrc={this.state.videoUrl} />
                                </div> : null
                        }

                    </div>


                </div>


                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);